const hexToRgba = require('hex-to-rgba')

module.exports = {
  primary: '#4ca456',
  secondary: '#899100',
  text: '#0e0e0e',
  backgroundHtml: '#F9F8F6',
  white: '#FFF',
  black: '#131313',
  grey: '#c1c1c1',
  darkGrey: '#6C6C6C',
  darkGrey2: '#484848',
  darkGrey3: '#3D3D3D',
  darkGrey4: '#394241',
  darkGrey5: '#202625',
  darkGrey6: '#252b2b',
  lightGrey: '#E0E0E0',
  lightGrey2: '#747474',
  lightGrey3: '#F5F5F5',
  lightGrey4: '#949494',
  yellow: '#FFC80A',
  yellow2: '#E5B004',
  lightYellow: '#FBEF75',
  green: '#289F30',
  green2: '#7bc868',
  lightGreen: '#F0F1DE',
  darkGreen: '#1F450B',
  darkGreen2: '#01300E',
  orange: '#F57D0D',
  error: '#f44336',
  mutedText: hexToRgba('#000', 0.54),
  muted: hexToRgba('#000', 0.23),
  link: '#3499bf',
  red: '#AF1010',
  redDark: '#A40100',
  transparent: 'transparent',
  plots: {
    app: '#DBFF1D',
    alr: '#048113',
    lake: '#0080FF'
  }
}
